// Données pour PRIsME Master BZ
import { carteEbaucheCadreBZ, communicationEbaucheCadreBZ } from './comitePRIsMECardsData';
import { carteGouvernancePRIsME2, communicationGouvernancePRIsME2 } from './carteGouvernancePRIsME2';
import { communicationPRIsMEPrimes } from './comitePRIsMECommunicationData';

type CarteID = 'ebauche-cadre-bz' | 'gouvernance-prisme-2-0' | 'communication-primes';

interface CartePRIsME {
  title: string;
  category: string;
  description: string;
  aiSuggestion: string;
  kpiScore: number;
  imageUrl: string;
  inKnowledgeBase: boolean;
}

// Collection de cartes
export const cartesPRIsME: Record<CarteID, { card: CartePRIsME, communication: any }> = {
  'ebauche-cadre-bz': {
    card: carteEbaucheCadreBZ,
    communication: communicationEbaucheCadreBZ
  },
  'gouvernance-prisme-2-0': {
    card: carteGouvernancePRIsME2,
    communication: communicationGouvernancePRIsME2
  },
  'communication-primes': {
    card: {
      title: 'Communication Officielle PRIsME aux Primes',
      category: 'Communication',
      description: 'Communication structurée aux Primes de BZ sur PRIsME: vision, architecture, valeur client et rôle des Primes.',
      aiSuggestion: 'Présentation complète pour aligner les Primes sur la vision PRIsME',
      kpiScore: 92,
      imageUrl: 'https://images.unsplash.com/photo-1531545514256-b1400bc00f31?w=1200&auto=format&fit=crop&q=80',
      inKnowledgeBase: true,
    },
    communication: communicationPRIsMEPrimes
  }
};

// Export des données
export {
  carteEbaucheCadreBZ,
  communicationEbaucheCadreBZ,
  carteGouvernancePRIsME2,
  communicationGouvernancePRIsME2,
  communicationPRIsMEPrimes
};

// API pour accéder aux cartes
export const getCartesPRIsME = () => {
  return Object.keys(cartesPRIsME).map(key => ({
    id: key,
    ...cartesPRIsME[key as CarteID].card
  }));
};

export const getCommunicationPRIsME = (id: string) => {
  if (!Object.keys(cartesPRIsME).includes(id)) return null;
  return cartesPRIsME[id as CarteID].communication;
};

export default {
  getCartesPRIsME,
  getCommunicationPRIsME
};